import { Component, h, Prop, State, Element } from '@stencil/core';
import { _BREAKPOINTS_ } from 'utils';

@Component({
    tag: 'kdx-overlay-cta',
    styleUrl: 'kdx-overlay-cta.scss',
    shadow: false
})
export class KdxOverlayCta {
    @Element() root: HTMLElement;

    @Prop() desktopImg: string;
    @Prop() mobileImg: string;
    @Prop() overlayStyle: 'dark' | 'light' = 'dark';

    @State() bgImage: string;
    @State() useMobileImg: boolean = false;

    setImg() {
        if (!Boolean(this.mobileImg) || this.mobileImg == '') {
            this.bgImage = this.desktopImg;
            this.useMobileImg = false;
        } else if (window.innerWidth >= 992) {
            this.bgImage = this.desktopImg;
            this.useMobileImg = false;
        } else {
            this.bgImage = this.mobileImg;
            this.useMobileImg = true;
        }
    }

    componentWillLoad() {
        this.setImg();
    }

    componentDidLoad() {
        this.setImg();

        window.addEventListener('resize', () => {
            this.setImg();
        });
    }

    render() {
        return (
            <div class={`kdx-overlay-cta ${this.overlayStyle}`}>
                <div class="overlay"></div>
                <picture>
                    <source media="(max-width: 991px)" srcSet={this.mobileImg} />
                    <img
                        src={this.desktopImg}
                        alt="Background"
                        class={`bg-image${this.useMobileImg ? " bg-image-mobile" : ""}`}
                        role="presentation"
                    />
                </picture>
                <div class="container cta-container">
                    <div class="cta-content">
                        <slot/>
                    </div>
                </div>
            </div>
        );
    }
}